var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#292929",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4116 10.0762C18.4116 12.5237 16.4492 14.4862 13.9999 14.4862C11.5515 14.4862 9.58826 12.5237 9.58826 10.0762C9.58826 7.62868 11.5515 5.66699 13.9999 5.66699C16.4492 5.66699 18.4116 7.62868 18.4116 10.0762ZM13.9999 22.3337C10.3852 22.3337 7.33325 21.7462 7.33325 19.4795C7.33325 17.212 10.4044 16.6453 13.9999 16.6453C17.6154 16.6453 20.6666 17.2328 20.6666 19.4995C20.6666 21.767 17.5954 22.3337 13.9999 22.3337Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoBlack);
export default __webpack_public_path__ + "static/media/user_logo_black.e4ca855070a2fb236e2cfabc511ebc87.svg";
export { ForwardRef as ReactComponent };